(() => {
  'use strict';
  const config = window.LoopLiora || {root: '/', currency: 'USD', locale: 'en'};
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const money = cents => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(cents / 100);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const timedVariantCache = new WeakMap();
  let timedSaleInterval;
  function timedPriceState(nativePrice, nativeCompare, start, end, percent, now) {
    const active = Number.isFinite(start) && Number.isFinite(end) && end > start && percent > 0 && percent < 100 && now >= start && now < end;
    const base = nativePrice;
    return {active, price: active ? Math.round(base * (100 - percent) / 100) : nativePrice, compare: active ? base : nativeCompare};
  }
  function refreshTimedPrices(scope = document) {
    const nodes = scope.matches?.('[data-timed-price]') ? [scope] : $$('[data-timed-price]', scope);
    const now = Date.now();
    nodes.forEach(node => {
      let nativePrice = Number(node.dataset.nativePrice), nativeCompare = Number(node.dataset.nativeCompare);
      const kind = node.dataset.priceKind;
      const section = (kind === 'main' || kind === 'sticky') && node.closest('[data-product-section]');
      if (section) {
        if (!timedVariantCache.has(section)) {
          try {timedVariantCache.set(section, JSON.parse($('[data-variants]', section)?.textContent || '[]'));} catch {timedVariantCache.set(section, []);}
        }
        const selectedId = $('[data-product-form] [name="id"]', section)?.value;
        const variant = timedVariantCache.get(section).find(item => String(item.id) === selectedId);
        if (variant) {nativePrice = Number(variant.price); nativeCompare = Number(variant.compare_at_price) || 0;}
      }
      const start = Date.parse(node.dataset.saleStart), end = Date.parse(node.dataset.saleEnd);
      const state = timedPriceState(nativePrice, nativeCompare, start, end, Number(node.dataset.salePercent), now);
      const onSale = state.compare > state.price;
      const signature = `${state.active}:${state.price}:${state.compare}`;
      if (node.dataset.priceState !== signature) {
        node.dataset.priceState = signature;
        const price = $('[data-product-price],[data-sticky-price],[data-card-price]', node);
        if (price) price.textContent = (node.dataset.pricePrefix || '') + money(state.price);
        const compare = $('[data-product-compare],[data-card-compare]', node);
        if (compare) {
          compare.hidden = !onSale;
          const value = $('[data-compare-value]', compare) || compare;
          value.textContent = onSale ? money(state.compare) : '';
        }
        const badge = $('[data-sale-badge]', node);
        if (badge) {badge.hidden = !onSale; badge.textContent = onSale ? badge.dataset.saleTemplate.replace('__PERCENT__', String(Math.round((state.compare - state.price) * 100 / state.compare))) : '';}
        if (kind === 'badge' && node.dataset.available === 'true') node.textContent = onSale ? node.dataset.saleLabel : node.dataset.regularLabel;
      }
      if (kind !== 'main') return;
      const offer = node.parentElement.querySelector('[data-timed-offer]');
      if (!offer) return;
      offer.hidden = !state.active;
      if (!state.active) return;
      const countdown = $('[data-sale-countdown]', offer);
      const countdownRow = $('[data-countdown-row]', offer);
      if (countdownRow) countdownRow.hidden = false;
      const remaining = Math.max(0, Math.ceil((end - now) / 1000));
      if (countdown) countdown.textContent = countdown.dataset.countdownTemplate
        .replace('__HOURS__', String(Math.floor(remaining / 3600)).padStart(2, '0'))
        .replace('__MINUTES__', String(Math.floor(remaining % 3600 / 60)).padStart(2, '0'))
        .replace('__SECONDS__', String(remaining % 60).padStart(2, '0'));
      const deadline = $('[data-sale-deadline]', offer);
      if (deadline && !deadline.dataset.localized) {
        deadline.textContent = new Intl.DateTimeFormat(config.locale, {year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'}).format(new Date(end));
        deadline.dataset.localized = 'true';
      }
    });
  }
  function initTimedPrices(scope = document) {
    refreshTimedPrices(scope);
    if (!timedSaleInterval && $('[data-timed-price]')) timedSaleInterval = setInterval(() => refreshTimedPrices(), 1000);
  }
  document.addEventListener('product:price-change', event => {
    $$('[data-timed-price]', event.target).forEach(node => {delete node.dataset.priceState;});
    refreshTimedPrices(event.target);
  });
  document.addEventListener('visibilitychange', () => {if (!document.hidden) refreshTimedPrices();});
  window.addEventListener('pageshow', () => refreshTimedPrices());

  const stringsNode = $('[data-commerce-strings]');
  let strings = {};
  try { strings = JSON.parse(stringsNode?.textContent || '{}'); } catch {}
  const t = (key, fallback) => strings[key] || fallback;
  const toast = message => {const node = $('[data-toast]'); if (!node) return; node.textContent = message; node.classList.add('is-visible'); clearTimeout(toast.timer); toast.timer = setTimeout(() => node.classList.remove('is-visible'), 4500);};
  const make = (tag, cls, content) => {const el = document.createElement(tag); if (cls) el.className = cls; if (content !== undefined) el.textContent = content; return el;};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const phoneLayout = window.matchMedia('(max-width: 650px)');
  const mobileLayout = window.matchMedia('(max-width: 900px)');
  const motionAllowed = () => document.body.classList.contains('motion-enabled') && !reducedMotion.matches && !document.documentElement.classList.contains('motion-paused');
  let revealObserver;
  function reveal(node) {node.classList.remove('reveal-pending');node.dataset.revealed='true';revealObserver?.unobserve(node);}
  function initReveals(scope=document) {
    if (!motionAllowed() || !('IntersectionObserver' in window)) {
      revealObserver?.disconnect();$$('.reveal-pending').forEach(reveal);return;
    }
    if (!revealObserver) revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {if(entry.isIntersecting)reveal(entry.target);});
    }, {rootMargin:'0px 0px 30px 0px',threshold:0});
    $$('[data-reveal]',scope).forEach((node,index) => {
      if(node.dataset.revealed || node.classList.contains('reveal-pending'))return;
      node.dataset.scrollReveal='';
      node.style.setProperty('--reveal-delay',`${Math.min(index % 3,2)*65}ms`);
      if(node.getBoundingClientRect().top < window.innerHeight + 30){reveal(node);return;}
      revealObserver.observe(node);node.classList.add('reveal-pending');
    });
  }
  function setMenu(open,focusToggle=false) {
    const button=$('[data-menu-toggle]'),nav=document.getElementById(button?.getAttribute('aria-controls'));if(!nav||!button)return;
    nav.hidden=!open;button.setAttribute('aria-expanded',String(open));button.setAttribute('aria-label',open?t('closeMenu','Close menu'):t('openMenu','Open menu'));
    if(focusToggle)button.focus();
  }
  function revealHashTarget() {
    let id;try{id=decodeURIComponent(location.hash.slice(1));}catch{return;}
    if(!id)return;const target=document.getElementById(id);if(!target)return;
    const composer=target.closest('[data-review-composer]');if(composer)composer.open=true;
    if(target.matches('[data-reveal]'))reveal(target);
  }
  function initReviewComposers(scope=document) {
    $$('[data-review-composer]',scope).forEach(composer=>{
      if(composer.dataset.initialized)return;composer.dataset.initialized='true';
      const hasStatus=$('.form-success,.form-error:not(:empty)',composer);
      if(phoneLayout.matches&&!hasStatus&&!composer.contains(document.activeElement))composer.open=false;
    });
    revealHashTarget();
  }
  function initReviewRails(scope=document) {
    $$('[data-review-controls]',scope).forEach(controls=>{
      if(controls.dataset.initialized)return;
      const section=controls.closest('.homepage-reviews'),rail=$('.review-grid',section),cards=$$('.review-card',rail);
      if(cards.length<2||$('.review-app',rail))return;
      controls.dataset.initialized='true';controls.classList.add('is-enhanced');
      const previous=$('[data-review-direction="-1"]',controls),next=$('[data-review-direction="1"]',controls),position=$('[data-review-position]',controls);
      const step=()=>cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||0);
      const update=()=>{const at=Math.max(0,Math.min(cards.length-1,Math.round(rail.scrollLeft/step())));position.textContent=`${at+1} / ${cards.length}`;previous.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;};
      controls.addEventListener('click',e=>{const button=e.target.closest('[data-review-direction]');if(!button)return;const index=Math.round(rail.scrollLeft/step())+Number(button.dataset.reviewDirection);rail.scrollTo({left:index*step(),behavior:motionAllowed()?'smooth':'auto'});});
      rail.addEventListener('scroll',update,{passive:true});
      if('ResizeObserver' in window){const observer=new ResizeObserver(update);observer.observe(rail);section.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});}
      update();
    });
  }
  window.addEventListener('hashchange',revealHashTarget);
  reducedMotion.addEventListener('change',()=>initReveals());
  mobileLayout.addEventListener('change',e=>{if(!e.matches)setMenu(false);});
  window.addEventListener('pageshow',()=>{if(!motionAllowed())initReveals();$$('[data-product-form]').forEach(form=>{delete form.dataset.submitting;form.removeAttribute('aria-busy');form.dispatchEvent(new Event('product:state'));});});
  let headerFrame;
  function updateHeader(){headerFrame=0;$('.site-header')?.classList.toggle('is-scrolled',window.scrollY>20);}
  window.addEventListener('scroll',()=>{if(!headerFrame)headerFrame=requestAnimationFrame(updateHeader);},{passive:true});
  let cartQueue = Promise.resolve();
  let pendingMutations = 0;
  let cartRequest = 0;
  let cartReturnFocus = null;
  async function jsonFetch(url, options) {
    const response = await fetch(url, {...options, headers:{Accept:'application/json', ...(options?.headers || {})}});
    let data; try { data = await response.json(); } catch { throw new Error(t('error','Something went wrong. Please try again.')); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : t('error','Please try again.'));
    return data;
  }
  function setCartBusy(busy) {
    $('[data-cart-body]')?.setAttribute('aria-busy', String(busy));
    $$('[data-cart-remove],[data-cart-checkout]').forEach(button => { button.disabled = busy; });
  }
  function mutateCart(url, options) {
    pendingMutations += 1;
    cartRequest += 1;
    setCartBusy(true);
    const operation = cartQueue.then(() => jsonFetch(url, options));
    cartQueue = operation.catch(() => {});
    return operation.finally(() => { pendingMutations -= 1; if (!pendingMutations) setCartBusy(false); });
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(n => n.textContent = cart.item_count);
    const body = $('[data-cart-body]'); if (!body) return;
    body.replaceChildren();
    $('[data-cart-footer]').hidden = cart.item_count === 0;
    $('[data-cart-subtotal]').textContent = money(cart.total_price);
    $('[data-cart-tax]').textContent = `${cart.taxes_included ? t('taxIncluded','Taxes included.') : t('taxCheckout','Taxes calculated at checkout where applicable.')} ${cart.requires_shipping ? t('shippingCheckout','Shipping calculated at checkout.') : t('noShipping','No physical items will be shipped.')}`;
    const discounts = $('[data-cart-discounts]');
    discounts.replaceChildren();
    (cart.cart_level_discount_applications || []).forEach(discount => discounts.append(make('p','',`${discount.title} −${money(discount.total_allocated_amount)}`)));
    if (!cart.item_count) {
      const empty = make('div','drawer-empty');
      empty.append(make('h3','',t('emptyTitle','A little empty. Full of possibility.')), make('p','muted',t('emptyBody','Find your next handmade project.')));
      const link = make('a','button',t('explore','Explore patterns')); link.href = root + 'collections/all'; empty.append(link); body.append(empty); return;
    }
    cart.items.forEach(item => {
      const article = make('article','drawer-item');
      const imageLink = make('a'); imageLink.href = item.url; imageLink.setAttribute('aria-label', item.product_title);
      if (item.image) {const img = make('img'); img.src = item.image; img.alt = item.product_title; img.width = 84; img.height = 96; imageLink.append(img);}
      const info = make('div'); const title = make('h3'); const titleLink = make('a','',item.product_title); titleLink.href = item.url; title.append(titleLink); info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(make('p','',item.variant_title));
      if(item.selling_plan_allocation?.selling_plan?.name) info.append(make('p','',item.selling_plan_allocation.selling_plan.name));
      Object.entries(item.properties || {}).forEach(([key,value]) => {if(value && !key.startsWith('_'))info.append(make('p','',`${key}: ${value}`));});
      info.append(make('p','',`${item.requires_shipping ? '' : t('digitalItem','Digital pattern') + ' · '}${t('quantity','Quantity')}: ${item.quantity}`));
      (item.line_level_discount_allocations || []).forEach(discount => info.append(make('p','',`${discount.discount_application.title} −${money(discount.amount)}`)));
      const bottom = make('div','item-bottom');
      const price = make('strong'); if(item.original_line_price > item.final_line_price)price.append(make('s','',money(item.original_line_price)),document.createTextNode(' ')); price.append(document.createTextNode(money(item.final_line_price)));bottom.append(price);
      const remove = make('button','',t('remove','Remove')); remove.type = 'button'; remove.dataset.cartRemove = item.key; remove.setAttribute('aria-label',`${t('remove','Remove')} ${item.product_title}`); remove.disabled=!!pendingMutations;bottom.append(remove); info.append(bottom); article.append(imageLink,info); body.append(article);
    });
  }
  async function openCart(opener) {
    const drawer = $('#CartDrawer');
    if (!drawer?.showModal) { location.href = root + 'cart'; return; }
    if (!drawer.open) { cartReturnFocus = opener || document.activeElement; drawer.showModal(); }
    $('[data-cart-error]').textContent = '';
    $('[data-cart-footer]').hidden = true;
    const body = $('[data-cart-body]');
    body.replaceChildren(make('p','',t('loading','Loading your bag…')));
    setCartBusy(true);
    await cartQueue;
    const request = ++cartRequest;
    try { const cart=await jsonFetch(root + 'cart.js'); if(request===cartRequest)renderCart(cart); }
    catch { if(request===cartRequest){body.replaceChildren(make('p','',t('loadError','Your bag could not be loaded.'))); const link=make('a','button',t('fullBag','View full bag')); link.href=root+'cart'; body.append(link);} }
    finally {if(request===cartRequest && !pendingMutations)setCartBusy(false);}
  }
  function initProduct(scope = document) {
    const sections = scope.matches?.('[data-product-section]') ? [scope] : $$('[data-product-section]', scope);
    sections.forEach(section => {
      if (section.dataset.initialized) return; section.dataset.initialized = 'true';
      let variants;try {variants = JSON.parse($('[data-variants]',section)?.textContent || '[]');} catch {return;}
      const form=$('[data-product-form]',section);
      const selectedVariant = () => variants.find(variant=>String(variant.id)===($('[name="id"]',form)?.value));
      function updateButtons() {
        const variant=selectedVariant(), busy=form.dataset.submitting==='true', unavailable=!variant?.available;
        const button=$('[data-add-to-cart]',section),label=$('[data-add-label]',section),sticky=$('[data-sticky-add]',section);
        button.disabled=busy||unavailable;
        label.textContent=busy?t('adding','Adding…'):unavailable?t('soldOut','Sold out'):t('add','Add pattern to bag');
        if(sticky){sticky.disabled=busy||unavailable;sticky.textContent=busy?(sticky.dataset.checkoutLoading||t('adding','Adding…')):unavailable?t('soldOut','Sold out'):(sticky.dataset.checkoutLabel||t('addShort','Add to bag'));}
      }
      form.addEventListener('product:state',updateButtons);
      function selectMedia(id) {
        if (!$(`[data-media-id="${id}"]`,section)) return;
        $$('[data-media-id]',section).forEach(node => {const wasHidden=node.hidden;node.hidden = node.dataset.mediaId !== String(id); if (node.hidden&&!wasHidden) {$$('video,model-viewer',node).forEach(media=>media.pause?.()); $$('iframe',node).forEach(frame=>{if(frame.src)frame.src=frame.src;});}});
        $$('[data-media-target]',section).forEach(node => {const active = node.dataset.mediaTarget === String(id); node.classList.toggle('is-active',active); node.setAttribute('aria-pressed',String(active));});
      }
      $$('[data-media-target]',section).forEach(button=>button.addEventListener('click',()=>selectMedia(button.dataset.mediaTarget)));
      const galleryStage=$('.product-media-stage',section),galleryItems=$$('[data-media-id]',galleryStage||section);
      if(galleryStage&&galleryItems.length>1&&'PointerEvent' in window){
        let gesture=null;
        galleryStage.classList.add('is-swipeable');
        galleryStage.addEventListener('pointerdown',event=>{
          if(!event.isPrimary){gesture=null;return;}
          if(event.button!==0||!event.target.closest('.product-main-image')||(window.visualViewport?.scale||1)>1.01)return;
          gesture={id:event.pointerId,x:event.clientX,y:event.clientY};
          galleryStage.setPointerCapture(event.pointerId);
        });
        galleryStage.addEventListener('pointermove',event=>{
          if(!gesture||event.pointerId!==gesture.id)return;
          const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
          if(Math.abs(dy)>12&&Math.abs(dy)>Math.abs(dx))gesture=null;
        },{passive:true});
        galleryStage.addEventListener('pointerup',event=>{
          if(!gesture||event.pointerId!==gesture.id)return;
          const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
          gesture=null;
          if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.5||(window.visualViewport?.scale||1)>1.01)return;
          const current=galleryItems.findIndex(item=>!item.hidden);
          if(current<0)return;
          const direction=getComputedStyle(galleryStage).direction==='rtl'?-1:1;
          const next=(current+(dx<0?1:-1)*direction+galleryItems.length)%galleryItems.length;
          selectMedia(galleryItems[next].dataset.mediaId);
          const thumbnail=$('[data-media-target].is-active',section),rail=thumbnail?.parentElement;
          if(rail){
            const itemRect=thumbnail.getBoundingClientRect(),railRect=rail.getBoundingClientRect();
            if(itemRect.left<railRect.left)rail.scrollBy({left:itemRect.left-railRect.left,behavior:'instant'});
            else if(itemRect.right>railRect.right)rail.scrollBy({left:itemRect.right-railRect.right,behavior:'instant'});
          }
        });
        const cancelGesture=()=>{gesture=null;};
        galleryStage.addEventListener('pointercancel',cancelGesture);
        galleryStage.addEventListener('lostpointercapture',cancelGesture);
        galleryStage.addEventListener('dragstart',event=>{if(event.target.closest('.product-main-image'))event.preventDefault();});
      }
      $('[data-variant-select]',section)?.addEventListener('change', e => {
        const variant = variants.find(v=>String(v.id)===e.target.value); if (!variant) return;
        $('[data-product-price]',section).textContent = variant.price_formatted || money(variant.price);
        const compare=$('[data-product-compare]',section); compare.hidden=!(variant.compare_at_price>variant.price); compare.textContent=variant.compare_at_price ? variant.compare_formatted || money(variant.compare_at_price) : '';
        section.dispatchEvent(new Event('product:price-change', {bubbles: true}));
        updateButtons();
        $('[data-product-error]',form).textContent='';
        if(variant.featured_media_id)selectMedia(variant.featured_media_id);
        const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url);
      });
      const selected = variants.find(v=>String(v.id)===($('[name="id"]',section)?.value));
      if(selected?.featured_media_id)selectMedia(selected.featured_media_id);
      updateButtons();
      $('[data-sticky-add]',section)?.addEventListener('click',event=>{if(!$('[data-add-to-cart]',form).disabled){form.loopLioraCartOpener=event.currentTarget;try{form.requestSubmit();}finally{delete form.loopLioraCartOpener;}}});
      const primaryButton=$('[data-add-to-cart]',section),stickyBar=$('.product-sticky',section);
      if(primaryButton&&stickyBar&&'IntersectionObserver' in window){
        const observer=new IntersectionObserver(entries=>{stickyBar.classList.toggle('is-hidden',entries[0].isIntersecting);},{rootMargin:'-80px 0px -68px 0px',threshold:0});
        observer.observe(primaryButton);
        section.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
      }
    });
  }
  document.addEventListener('click', async e => {
    const menu = e.target.closest('[data-menu-toggle]');
    if(menu)setMenu(menu.getAttribute('aria-expanded')!=='true');
    else if(e.target.closest('.mobile-nav a')||!e.target.closest('.mobile-nav'))setMenu(false);
    const reviewOpen=e.target.closest('[data-review-open]');
    if(reviewOpen&&!e.ctrlKey&&!e.metaKey){
      const target=document.getElementById(reviewOpen.hash.slice(1));
      if(target){e.preventDefault();const composer=target.closest('[data-review-composer]');if(composer)composer.open=true;target.focus({preventScroll:true});target.scrollIntoView({behavior:motionAllowed()?'smooth':'auto',block:'start'});history.replaceState(null,'',reviewOpen.hash);}
    }
    const cartOpen=e.target.closest('[data-cart-open]');
    if(cartOpen&&!e.ctrlKey&&!e.metaKey&&!e.shiftKey&&!e.altKey){e.preventDefault();openCart(cartOpen);}
    if(e.target.closest('[data-cart-close]'))$('#CartDrawer')?.close();
    const remove=e.target.closest('[data-cart-remove]');
    if(remove&&!remove.disabled){$('[data-cart-error]').textContent='';try{const cart=await mutateCart(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})});renderCart(cart);$('[data-cart-close]')?.focus();toast(t('updated','Your bag has been updated.'));}catch(err){$('[data-cart-error]').textContent=err.message;}}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){const activeDropdown=document.activeElement?.closest('.nav-dropdown[open]');const button=$('[data-menu-toggle]'),nav=document.getElementById(button?.getAttribute('aria-controls'));if(nav&&!nav.hidden)setMenu(false,true);$$('.nav-dropdown[open]').forEach(d=>d.open=false);activeDropdown?.querySelector('summary')?.focus();}});
  document.addEventListener('focusin',e=>{const node=e.target.closest('[data-reveal]');if(node)reveal(node);});
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('[data-product-form]');if(!form||!window.fetch)return;
    e.preventDefault();if(form.dataset.submitting||$('[data-add-to-cart]',form).disabled)return;
    form.dataset.submitting='true';const button=$('[data-add-to-cart]',form), label=$('[data-add-label]',form), error=$('[data-product-error]',form);
    const opener=form.loopLioraCartOpener || e.submitter || button;
    const payload=new FormData(form);
    const directCheckout=opener.hasAttribute('data-sticky-checkout');
    let navigating=false;
    button.disabled=true;label.textContent=t('adding','Adding…');error.textContent='';form.setAttribute('aria-busy','true');form.dispatchEvent(new Event('product:state'));
    try{
      let shouldAdd=true;
      if(directCheckout){
        await cartQueue;
        const cart=await jsonFetch(root+'cart.js');
        const quantity=Math.max(1,Number(payload.get('quantity'))||1);
        const customItem=[...payload.keys()].some(key=>key.startsWith('properties[')||(key==='selling_plan'&&payload.get(key)));
        const existing=!customItem&&cart.items.find(item=>String(item.variant_id)===String(payload.get('id'))&&!item.selling_plan_allocation&&!Object.keys(item.properties||{}).length);
        if(existing){shouldAdd=existing.quantity<quantity;if(shouldAdd)payload.set('quantity',String(quantity-existing.quantity));}
      }
      if(shouldAdd)await mutateCart(root+'cart/add.js',{method:'POST',body:payload});
      if(directCheckout){
        const checkoutButton=$('[data-cart-checkout]');
        if(checkoutButton?.form)checkoutButton.form.requestSubmit(checkoutButton);
        else location.assign(root+'checkout');
        navigating=true;
      }else await openCart(opener);
    }
    catch(err){error.textContent=err.message;toast(t('addFailed','The pattern was not added. Please try again.'));}
    finally{if(!navigating){delete form.dataset.submitting;form.removeAttribute('aria-busy');form.dispatchEvent(new Event('product:state'));}}
  });
  document.addEventListener('change',e=>{if(e.target.matches('[data-sort-by]'))e.target.form.requestSubmit();});
  $('#CartDrawer')?.addEventListener('click',e=>{if(e.target!==e.currentTarget)return;const r=e.currentTarget.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)e.currentTarget.close();});
  $('#CartDrawer')?.addEventListener('close',()=>{if(!cartReturnFocus?.isConnected)return;const target=cartReturnFocus.disabled?(cartReturnFocus.closest('[data-product-section]')?.querySelector('[data-variant-select]') || $('[data-cart-open]')):cartReturnFocus;target?.focus();});
  function setMotion(paused){document.documentElement.classList.toggle('motion-paused',paused);initReveals();}
  try{localStorage.removeItem('loopliora-motion-paused');}catch{}setMotion(false);
  async function initRecommendations(scope=document){for(const node of $$('[data-recommendations]',scope)){if(node.dataset.loaded||!node.dataset.url)continue;node.dataset.loaded='true';try{const response=await fetch(node.dataset.url);if(!response.ok)continue;const html=await response.text();const doc=new DOMParser().parseFromString(html,'text/html');const section=$('[data-recommendations]',doc);if(section?.innerHTML.trim()){node.innerHTML=section.innerHTML;initReveals(node);initTimedPrices(node);}}catch{}}}
  initProduct();initTimedPrices();initRecommendations();initReviewComposers();initReviewRails();updateHeader();
  document.addEventListener('shopify:section:load',e=>{initProduct(e.target);initTimedPrices(e.target);initRecommendations(e.target);initReviewComposers(e.target);initReviewRails(e.target);updateHeader();setMotion(false);});
  document.addEventListener('shopify:block:select',e=>{const node=e.target.closest('[data-reveal]');if(node)reveal(node);const composer=e.target.closest('[data-review-composer]');if(composer)composer.open=true;});
})();


